// ** Redux Imports
import { combineReducers } from 'redux'

// ** Reducers Imports
import authReducer from './Auth/AuthSlice'

const rootReducer = combineReducers({
  auth: authReducer,
})

export default rootReducer
